
<script>
const SPLITOR = "=";
const parseSpace = function (str) {
  return str
    .replace(/(^\s*)|(\s*$)/g, "")
    .split(" ")
    .join(SPLITOR);
};

export default {
  parseSpace,
  SPLITOR,
  // 网络配置
  // IP: "http://127.0.0.1:8088/",
  
  PUBMED_URL: "https://www.ncbi.nlm.nih.gov/pubmed/",
   rootAddress:"https://www.csuligroup.com/depression_analysis/", 
  //rootAddress:"http://127.0.0.1:8080/"
};
</script>

<style>

/* 表格 */
    .el-table .cell {
        word-break: break-word !important;
    }
    .el-pager li.active{
    color:rgb(255,208,75) !important;/*仅设置active时的文字颜色*/
    }
    .el-pager li:hover{
    color:rgb(255,208,75) !important;/*仅设置active时的文字颜色*/
    }
    .el-input__inner:focus {
        border: 1px solid rgb(255,208,75) !important;
      }
    .el-input__inner:hover {
        border: 1px solid rgb(255,208,75) !important;
    }
    .btn-prev:hover{ 
        color: rgb(255,208,75) !important;
      }
    .btn-next:hover{ 
        color: rgb(255,208,75) !important;
      }
    .el-select-dropdown__item.selected{
        color: rgb(255,208,75) !important;
    }
    .el-table .ascending .sort-caret.ascending{
      border-bottom-color: rgb(230,162,60) !important;
    }
    .el-table .descending .sort-caret.descending{
      border-top-color: rgb(230,162,60) !important;
    }
    .el-table {

      width: 100%;

      display: flex;

      flex-direction: column;


      }
      .el-table__body-wrapper {

      flex: 1;

      }

/* tab */
  .el-tabs__header
     .el-tabs__item:hover{ 
        color: black!important;
   }
   .el-tabs__item.is-active{ 
       color: black!important;
   }
   .el-tabs__item{ 
       color: rgba(193,193,193)!important;
   }
   .el-tabs__active-bar{
        background-color:black !important;
    }
/* input */
    .el-textarea__inner:focus {
      border: rgb(230,162,60) 1px solid !important;
    }
   .el-upload-dragger:hover{
      border: rgb(230,162,60) 1px dashed !important;
   }
    .el-upload-dragger:focus{
      border: rgb(230,162,60) 1px dashed !important;
   }
   .el-upload-dragger{
      border: rgb(220,223,230) 1px dashed !important;
   }
   .el-upload.el-upload--text{
      width:100% !important;
   }
   .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
      border-color: rgb(230,162,60) !important;
   }

/* checkbox */
   .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color:rgb(230,162,60) !important;
      border-color: rgb(230,162,60) !important;
   }
   .el-checkbox__input.is-checked+.el-checkbox__label {
      color: rgb(230,162,60) !important;
   }
   .el-checkbox__label{
      font-size: 20px !important;
   }
   .el-checkbox__input.is-focus .el-checkbox__inner{
      border-color: rgb(230,162,60)  !important;
   }
   .el-checkbox__inner:hover{
      border-color: rgb(230,162,60) !important;
   }
   .el-loading-spinner .path{
  stroke: rgb(230,162,60);
  }
.el-loading-mask{
  background-color: rgba(0,0,0,0);
}

.el-upload-dragger{
      height:120px !important;
      margin-left:5% !important;
      margin-right:5% !important;
      margin-top: 0;
      width:90% !important;
      
   }
   .el-icon-upload{
      margin: 10px 0 0px !important;
    }
    .el-card__body{
      padding:15px !important;
    }
    .el-upload-list__item:first-child{
      margin-top: 0 !important;
    }
    /* select */
    .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
      color: rgb(230,162,60) !important;
    font-weight: 700;
}
</style>